// import { request } from '../utils/Api';

export function updateAppState(fields) { // eslint-disable-line
  return dispatch => (
    new Promise((resolve) => {
      dispatch({
        type: 'UPDATE_APP_STATE',
        payload: fields,
      });

      resolve();
    })
  );
}



// WEBPACK FOOTER //
// ./src/actions/applicationState.js